<div class="govuk-grid-row" *ngIf="!serviceUnavailable">
    <div class="govuk-grid-column-full">
        <h1 class="govuk-heading-xl">{{this.selectedDepartment?.extra?.services_page_title}}</h1>
    </div>

    <div class="govuk-grid-column-full" [innerHTML]="this.selectedDepartment?.extra?.service_page_introduction"></div>

    <div class="govuk-grid-column-full">
        <!-- Hardcoded initial questions -->
        <form [formGroup]="initQuestions" *ngIf="loadedConfig">

            <!-- <div class="govuk-form-group">
                <label class="govuk-label govuk-fieldset__legend--m" for="location">
                    Is the ceremony more than 2 years away?
                </label>
             
                <select (change)="validateCeramonyQuestion()" formControlName="ceramony_two_years" class="govuk-select"
                    id="location" name="location">
                    <option value="" selected></option>
                    <option *ngFor="let option of ceramony_options" [value]="option.option">
                        {{option.option}}
                    </option>
                </select>
            </div> -->

            <div class="govuk-form-group">
                <label class="govuk-label govuk-fieldset__legend--m" for="ceramony_type">
                    Which type of ceremony are you booking?
                </label>
                <select *ngIf="!adminOnlyJourney" (change)="validateCeramonyTypeQuestion()"
                    formControlName="type_of_ceramony" class="govuk-select" id="ceramony_type" name="ceramony_type">
                    <option value="" selected></option>
                    <option *ngFor="let option of config['ceramony_type_options']" [value]="option.id">
                        {{option.name}}
                    </option>
                </select>

                <select *ngIf="adminOnlyJourney" (change)="validateCeramonyTypeQuestion()"
                    formControlName="type_of_ceramony" class="govuk-select" id="ceramony_type" name="ceramony_type">
                    <option value="" selected></option>
                    <option *ngFor="let option of config['ceramony_type_options_admin']" [value]="option.id">
                        {{option.name}}
                    </option>
                </select>
            </div>

            <div class="govuk-inset-text" *ngIf="invalidInitForm == 'over_two_years'">
                {{'SERVICES.CERMONY_ADVISE' | translate}}
            </div>
        </form>

        <div *ngIf="showOther" [innerHTML]="this.selectedDepartment?.extra?.service_page_type_of_ceremony_other"></div>

        <form [formGroup]="companyQuestionsForm" *ngIf="!showOther">
            <div *ngFor="let question of companyQuestions;">
                <!-- <pre> {{question.name}} - {{question.id}} - {{question.detail_type}} - {{question.visible}} - {{ question.conditionals | json }}</pre> -->

                <!-- address lookup single field-->
                <div [ngClass]="{'hidden-question': question.hidden}"
                    *ngIf="question.visible && question.address_lookup">

                    <div class="govuk-form-group">
                        <label class="govuk-label govuk-label--m" for="postcode_{{question.reference}}">
                            {{question.name}}
                        </label> 
                        <input (keydown.space)="$event.preventDefault();" (keydown.spacebar)="$event.preventDefault();"
                            class="govuk-input govuk-input--width-20" id="postcode_{{question.reference}}"
                            name="postcode_{{question.reference}}" placeholder="Enter postcode"
                            formControlName="postcode_{{question.reference}}" type="text">
                    </div>

                    <button type="button" class="govuk-button" data-module="govuk-button"
                        (click)="getAddress(question)">
                        {{'COMMON.FIND_ADDRESS' | translate}}
                    </button>

                    <div *ngIf="question.addresses">
                        <div class="govuk-form-group" *ngIf="question.addresses.length > 0">
                            <label class="govuk-label govuk-fieldset__legend--m" style="color: #00703c;"
                                for="addresses">
                                * Select address below
                            </label>
                            <select (change)="validateQuestions($event, question); onQuestionChange(); setAddress($event, question);"
                                formControlName="{{question.reference}}" class="govuk-select" id="addresses"
                                name="addresses">

                                <!-- Hidden placeholder shown only when no value is selected -->
                                <option value="" disabled selected hidden>Select address</option>

                                <ng-container *ngFor="let option of question['addresses']">
                                    <option [value]="option.address['ADDRESS']">
                                        {{option.address['ADDRESS']}}
                                    </option>
                                </ng-container>

                            </select>
                        </div>
                    </div>
                </div>

                <span *ngIf="question.visible && !question.address_lookup">
                    <!-- select -->
                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'select' || question.visible && question.detail_type == 'select-price'">
                        <label class="govuk-label govuk-fieldset__legend--m" for="{{question.reference}}">
                            {{question.name}}
                        </label>
                        <select (change)="validateQuestions($event, question); onQuestionChange();"
                            formControlName="{{question.reference}}" class="govuk-select" id="{{question.reference}}"
                            name="{{question.reference}}">
                            <option value="" selected></option>
                            <option *ngFor="let option of question.options" [value]="option.name">
                                {{option.name}}
                            </option>
                        </select>
                    </div>

                    <!-- <div [ngClass]="{'hidden-question': question.hidden}" class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'select' || question.visible && question.detail_type == 'select-price'">
                        <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                *</span> {{question.name | translateSplit}}</label>

                        <ng-select [searchable]="false" [clearable]="false" appearance="outline"
                            id="{{question.reference}}" formControlName="{{question.reference}}" bindLabel="name"
                            bindValue="name" [items]="question.options"
                            (change)="validateQuestions($event, question); onQuestionChange();">
                        </ng-select>

                        <span *ngIf="question.helptext" class="help-text mb-3 pb-3" tabindex="0"
                            [innerHTML]="question.helptext | translateSplit | noSanitise">
                        </span>
                        <div *ngIf="form[question.reference].errors && showServices" class="invalid-feedback">
                            <div *ngIf="form[question.reference].errors.required" role="alert">
                                {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit } }}</div>

                            <ng-container *ngIf="question.required && showServices && !companyQuestionsForm.valid">
                                <p class="invalid-feedback">This question is required</p>
                            </ng-container>
                        </div>
                    </div> -->

                    <!-- text field -->
                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'text_field' && !question.resource_lookup">
                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--m" for="{{question.reference}}">
                                {{question.name}}
                            </label>
                        </h1>
                        <input class="govuk-input" name="eventName" id="{{question.reference}}" type="text"
                            formControlName="{{question.reference}}"
                            (change)="validateQuestions($event, question); onQuestionChange();">
                    </div>

                    <!-- RESOURCE LOOKUP text field -->
                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'text_field' && question.resource_lookup">
                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-fieldset__legend--m" for="{{ question.reference }}">
                                {{ question.name }}
                            </label>
                        </h1>
                        <div class="govuk-input__wrapper">
                            <input placeholder="Start typing to search..." name="eventName"
                                formControlName="{{ question.reference }}" id="{{ question.reference }}"
                                class="govuk-input govuk-input--with-clear" type="text"
                                (keyup)="onSearch($event, question)" [value]="searchText" autocomplete="off" />
                            <div *ngIf="searchText" type="button" class="govuk-input__suffix" aria-label="Clear search"
                                aria-hidden="true" (click)="clearSearch(question)">
                                <b>X</b>
                            </div>
                        </div>
                        <span *ngIf="question.searching" class="govuk-hint">
                            Searching...
                        </span>
                        <span *ngIf="question.noResults" class="govuk-hint">
                            No results found
                        </span>
                        <ul *ngIf="suggestions?.length && !question.selected_resource"
                            class="govuk-list govuk-list--search-results">
                            <li *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion, question)"
                                class="govuk-list__item">
                                <span class="govuk-list__item-icon">
                                    <img src="./assets/images/search.svg" alt="Search icon" />
                                </span>
                                {{ suggestion.pretty_name || suggestion.venue_name }}
                            </li>
                        </ul>
                    </div>


                    <!-- text area -->
                    <div class="govuk-form-group" *ngIf="question.visible && question.detail_type == 'text_area'">
                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--m" for="{{question.reference}}">
                                {{question.name}}
                            </label>
                        </h1>
                        <div id="{{question.reference}}-hint" class="govuk-hint">
                            {{question.helptext}}
                        </div>
                        <textarea formControlName="{{question.reference}}" class="govuk-textarea"
                            id="{{question.reference}}" name="moreDetail" rows="5"
                            (change)="validateQuestions($event, question); onQuestionChange();"></textarea>
                    </div>

                    <div *ngIf="question.visible && question.detail_type == 'date'" class="govuk-form-group">
                        <fieldset class="govuk-fieldset" role="group" [attr.aria-describedby]="question.helptext ? question.id : null">
                            <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                                <h1 class="govuk-fieldset__heading">
                                    {{question.name}}
                                </h1>
                            </legend>
                            <div id="{{question.id}}" class="govuk-hint" *ngIf="question.helptext"
                                [innerHTML]="question.helptext">
                            </div>
                            <div class="govuk-date-input" id="passport-issued">
                                <div class="govuk-date-input__item">
                                    <div class="govuk-form-group" [ngClass]="{
                                        'govuk-form-group--error': 
                                          (form[question.reference].errors?.required || 
                                           form[question.reference].errors?.pattern || 
                                           form[question.reference].errors?.minlength || 
                                           form[question.reference].errors?.maxlength ||
                                           form[question.reference].errors?.pastDate ||
                                           form[question.reference].errors?.futureDate)
            
                                      }">
                                        <label class="govuk-label govuk-date-input__label" for="{{question.id}}_d">
                                            Day
                                        </label>
                                        <input
                                            [ngClass]="{'govuk-input--error': form[question.reference].errors?.required == true }"
                                            (change)="validateQuestions($event, question); onQuestionChange();"
                                            class="govuk-input govuk-date-input__input govuk-input--width-2"
                                            id="{{question.id}}_d" name="{{question.id}}_d" type="text"
                                            inputmode="numeric">
                                    </div>
                                </div>
                                <div class="govuk-date-input__item">
                                    <div class="govuk-form-group" [ngClass]="{
                                        'govuk-form-group--error': 
                                        (form[question.reference].errors?.required || 
                                           form[question.reference].errors?.pattern || 
                                           form[question.reference].errors?.minlength || 
                                           form[question.reference].errors?.maxlength ||
                                           form[question.reference].errors?.pastDate ||
                                           form[question.reference].errors?.futureDate)
            
                                      }">
                                        <label class="govuk-label govuk-date-input__label" for="{{question.id}}_m">
                                            Month
                                        </label>
                                        <input
                                            [ngClass]="{'govuk-input--error': form[question.reference].errors?.required == true }"
                                            (change)="validateQuestions($event, question); onQuestionChange();"
                                            class="govuk-input govuk-date-input__input govuk-input--width-2"
                                            id="{{question.id}}_m" name="{{question.id}}_m" type="text"
                                            inputmode="numeric">
                                    </div>
                                </div>
                                <div class="govuk-date-input__item">
                                    <div class="govuk-form-group" [ngClass]="{
                                        'govuk-form-group--error': 
                                        (form[question.reference].errors?.required || 
                                           form[question.reference].errors?.pattern || 
                                           form[question.reference].errors?.minlength || 
                                           form[question.reference].errors?.maxlength ||
                                           form[question.reference].errors?.pastDate ||
                                           form[question.reference].errors?.futureDate)
            
                                      }">
                                        <label class="govuk-label govuk-date-input__label" for="{{question.id}}_y">
                                            Year
                                        </label>
                                        <input
                                            [ngClass]="{'govuk-input--error': form[question.reference].errors?.required == true }"
                                            (change)="validateQuestions($event, question); onQuestionChange();"
                                            class="govuk-input govuk-date-input__input govuk-input--width-4"
                                            id="{{question.id}}_y" name="{{question.id}}_y" type="text"
                                            inputmode="numeric">
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <!-- date -->
                    <!-- <div [ngClass]="{'hidden-question': question.hidden}" class="govuk-form-group   "
                        *ngIf="question.visible && question.detail_type == 'date'">
                        <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                *</span> {{question.name | translateSplit}}</label>

                        <input type="date" class="form-control govuk-input" formControlName="{{question.reference}}"
                            attr.aria-label="{{question.name}} date input" onkeydown="return false"
                            [attr.min]="question.hide_dates_in_past ? question.hide_dates_in_past : null"
                            [attr.max]="question.hide_dates_in_future ? question.hide_dates_in_future : null"
                            (change)="validateQuestions($event, question); onQuestionChange();">

                        <div *ngIf="form[question.reference].errors && showServices" class="invalid-feedback">
                            <div *ngIf="form[question.reference]?.errors?.required" role="alert">{{question.name}}
                                {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                            </div>

                            <ng-container *ngIf="question.required && showServices && !companyQuestionsForm.valid">
                                <p class="invalid-feedback">This question is required</p>
                            </ng-container>
                        </div>
                    </div> -->

                    <!-- GOVUK radio -->
                    <div *ngIf="question.visible && question.detail_type == 'radio'" class="govuk-form-group">
                        <fieldset class="govuk-fieldset" [attr.aria-describedby]="question.helptext ? 'changedName-hint-' + question.reference : null">
                            <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                                {{question.name}}
                            </legend>
                            <div id="changedName-hint-{{question.reference}}" class="govuk-hint" *ngIf="question.helptext"
                                [innerHTML]="question.helptext">
                            </div>
                            <div class="govuk-radios" data-module="govuk-radios">
                                <div class="govuk-radios__item" *ngFor="let option of question.options">
                                    <input formControlName="{{question.reference}}"
                                        (change)="updateRadio(companyQuestionsForm,question.reference,option.name)"
                                        class="govuk-radios__input" id="{{question.reference + '_' + option.name}}"
                                        name="{{question.reference}}" type="radio" [value]="option.name">
                                    <label class="govuk-label govuk-radios__label"
                                        for="{{question.reference + '_' + option.name}}">
                                        {{option.name}}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <!--CHECKBOX-->
                    <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'check'">
                        <fieldset class="govuk-fieldset" [attr.aria-describedby]="question.id">
                            <!-- <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                                <h1 class="govuk-fieldset__heading">
                                  Which types of waste do you transport?
                                </h1>
                              </legend> -->
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                            <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                                <div class="govuk-checkboxes__item">
                                    <input (change)="validateQuestions($event, question); onQuestionChange();"
                                        class="govuk-checkboxes__input" id="{{question.id}}" name="{{question.id}}"
                                        type="checkbox" value="{{question.id}}" formControlName="{{question.id}}">
                                    <label class="govuk-label govuk-checkboxes__label" for="{{question.id}}">
                                        {{question.name}}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <!-- <div [ngClass]="{'hidden-question': question.hidden}" class="  "
                        *ngIf="question.visible && question.detail_type === 'check'" class="govuk-checkboxes   "
                        data-module="govuk-checkboxes">
                        <span *ngIf="question.helptext" class="help-text mb-3" tabindex="-1"
                            [innerHTML]="question.helptext">
                        </span>

                        <div class="govuk-checkboxes__item">
                            <input id="{{question.id}}"
                                (change)="validateQuestions($event, question); onQuestionChange();"
                                class="govuk-checkboxes__input" type="checkbox" formControlName="{{question.id}}">
                            <label for="{{question.id}}" class="govuk-label govuk-checkboxes__label">
                                {{question.name}}
                            </label>
                        </div>

                        <ng-container *ngIf="question.required && showServices && !companyQuestionsForm.valid">
                            <p class="invalid-feedback">This question is required</p>
                        </ng-container>
                    </div> -->

                    <!-- normal heading-->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.detail_type == 'heading' && !question.conditionals.component_type">
                        <p [ngStyle]="{'color': question.customLabelColour}">
                            <b>{{question.name}}</b>
                        </p>
                        <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                            [innerHTML]="question.helptext">
                        </div>
                    </div>

                                  <!-- file upload heading -->
              <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.detail_type === 'heading' &&
                question.conditionals.component_type === 'file-upload'"
              >
                <div class="govuk-form-group">
                  <label class="govuk-label govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m-inverse" for="{{ question.id }}">
                    {{ question.name }}
                  </label>
                  <input (change)="
                      validateQuestions($event, question); onQuestionChange()" class="govuk-file-upload"
                    id="{{ question.id }}" name="question.id" type="file">
                </div>
              </div>

                    <!-- inset heading -->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'inset_text'">
                        <div class="govuk-inset-text">
                            {{question.name}}
                        </div>
                        <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                            [innerHTML]="question.helptext">
                        </div>
                    </div>

                    <!-- details component type -->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'details'">
                        <details class="govuk-details">
                            <summary class="govuk-details__summary">
                                <span class="govuk-details__summary-text">
                                    {{question.name}}
                                </span> 
                            </summary>
                            <div class="govuk-details__text" [innerHTML]="addHyperlinks(question)"></div>
                        </details>
                        <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                            [innerHTML]="question.helptext">
                        </div>
                    </div>

                    <!-- notifcation banner heading -->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'notification_banner'">

                        <div class="govuk-notification-banner" role="region"
                            aria-labelledby="govuk-notification-banner-title" data-module="govuk-notification-banner">
                            <div class="govuk-notification-banner__header">
                                <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                                    {{question.name}}
                                </h2>
                            </div>
                            <div class="govuk-notification-banner__content">
                                <p class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse"
                                    [innerHTML]="addHyperlinks(question)">
                                </p>
                            </div>
                        </div>
                        <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                            [innerHTML]="question.helptext">
                        </div>
                    </div>

                    <!-- warning heading -->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'warning_text'">

                        <div class="govuk-warning-text">
                            <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
                            <strong class="govuk-warning-text__text">
                                <span class="govuk-visually-hidden">Warning</span>
                                {{question.name}}
                            </strong>
                        </div>
                        <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                            [innerHTML]="question.helptext">
                        </div>
                    </div>

                    <!-- panel heading -->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'panel'">

                        <div class="govuk-panel govuk-panel--confirmation">
                            <h1 class="govuk-panel__title">
                                {{question.name}}
                            </h1>
                            <div class="govuk-panel__body" [innerHTML]="addHyperlinks(question)"></div>
                        </div>
                        <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                            [innerHTML]="question.helptext">
                        </div>
                    </div>

                    <!-- heading 2 -->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.detail_type == 'heading_2'">
                        <h2 class="govuk-heading-l" [ngStyle]="{'color': question.customLabelColour}">{{question.name}}
                        </h2>
                        <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                            [innerHTML]="question.helptext">
                        </div>
                    </div>

                    <!-- validation errors -->
                    <ng-container *ngIf="!form[question.reference].pristine && form[question.reference]?.errors"
                        id="event-name-error" class="govuk-error-message">
                        <!-- required -->
                        <ng-container *ngIf="form[question.reference]?.errors?.required">
                            <span class="govuk-visually-hidden">Error:</span>
                            {{ 'COMMON.IS_REQUIRED' | translate: { value: question.name } }}
                        </ng-container>
                        <!-- pattern -->
                        <ng-container *ngIf="form[question.reference]?.errors?.pattern">
                            <span class="govuk-visually-hidden">Error:</span>
                            {{ 'COMMON.INVALID' | translate: { value: question.name } }}
                        </ng-container>
                        <!-- email patttern -->
                        <ng-container *ngIf="form[question.reference]?.errors?.email">
                            <span class="govuk-visually-hidden">Error:</span>
                            {{ 'COMMON.INVALID' | translate: { value: question.name } }}
                        </ng-container>
                        <!-- minlength -->
                        <ng-container *ngIf="form[question.reference]?.errors?.minlength">
                            <span class="govuk-visually-hidden">Error:</span>
                            {{ 'COMMON.INVALID' | translate: { value: question.name } }}
                        </ng-container>
                        <!-- maxlength -->
                        <ng-container *ngIf="form[question.reference]?.errors?.maxlength">
                            <span class="govuk-visually-hidden">Error:</span>
                            {{ 'COMMON.INVALID' | translate: { value: question.name } }}
                        </ng-container>
                        <!-- pastDate -->
                        <ng-container *ngIf="form[question.reference]?.errors?.pastDate">
                            <span class="govuk-visually-hidden">Error:</span>
                            {{ 'COMMON.PAST_DATE' | translate: { value: question.name } }}
                        </ng-container>
                        <!-- futureDate -->
                        <ng-container *ngIf="form[question.reference]?.errors?.futureDate">
                            <span class="govuk-visually-hidden">Error:</span>
                            {{ 'COMMON.FUTURE_DATE' | translate: { value: question.name } }}
                        </ng-container>
                    </ng-container>
                </span>
            </div>
        </form>

        <div *ngIf="showServices && companyQuestionsForm.valid">
            <div class="govuk-button-group">
                <button type="submit" class="govuk-button" data-module="govuk-button"
                    (click)="selectService()">{{'COMMON.NEXT' |
                    translate}}
                </button>
            </div>
        </div>

        <ng-container *ngIf="showServices && !companyQuestionsForm.valid">
            <div role="alert" class="guidance-message cannot-proceed ng-star-inserted">
                <p><strong>Please complete the form above to proceed</strong>.</p>
            </div>
        </ng-container>

        <div *ngIf="!ageType.includes('16') && ageType.includes('10')">
            <div class="alert alert-danger mb-3" role="alert">
                <!-- {{ 'COMMON.HAS_COVID_SYMPTOMS' | translate }} -->
                <div class="pageTitle" *ngIf="translateService.currentLang == 'en'">
                    {{this.selectedDepartment?.extra?.under_10_guidance_text}}
                </div>
                <div class="pageTitle" *ngIf="translateService.currentLang == 'cy'">
                    {{this.selectedDepartment?.extra?.under_10_guidance_text_welsh}}
                </div>
            </div>

        </div>
    </div>
</div>
<div class="govuk-grid-row" *ngIf="serviceUnavailable">
  <p class="govuk-body">Ceremony bookings online will be available from Thursday 22nd May 2025. If you would like to make a ceremony booking before then, please call Tel: 0345 603 7632.</p>
</div>